export const Stamp = ({ children, className = "", ...props }) => {
  return (
    <span className={`stamp-chip ${className}`} {...props}>
      {children}
    </span>
  );
};
